export default {
  Student: 'Student',
  BirthCertificateForTheChild: 'Child Birth Certificate',
  FatherID: 'Father ID',
  MotherID: 'Mother ID'
}
